import React from 'react';
import { Field } from '@atlaskit/form';
import { BillEstimateOrderItemDto } from '@css-xp/common-services/src/api/gateways/ccp-gateways/src/ccp-api-order';
import { PriceDifferenceContent } from './price-difference-content';
import './price-difference.scss';

export type Estimate = {
  response?: {
    estimate: BillEstimateOrderItemDto;
    linkedEstimates?: BillEstimateOrderItemDto[];
  };
  error?: any;
  loading?: boolean;
};

type PriceDifferenceProps = {
  currentEstimatedBill?: number;
  estimatedBill: Estimate;
  setGrandTotal?: (_value: number) => void;
  hideAdminFeeTooltip?: boolean;
  shouldShowProratedCharge?: boolean;
  currency?: string;
  isDesignIteration1Enabled?: boolean;
};

export const PriceDifference = ({
  currentEstimatedBill = 0,
  estimatedBill,
  setGrandTotal,
  hideAdminFeeTooltip = true,
  shouldShowProratedCharge = false,
  currency,
  isDesignIteration1Enabled,
}: PriceDifferenceProps) => {
  const isLoading = !!estimatedBill?.loading;

  const renderPriceDifferenceContent = () => {
    return (
      <PriceDifferenceContent
        isLoading={isLoading}
        billEstimate={estimatedBill.response?.estimate}
        linkedEntitlementsBillEstimate={estimatedBill.response?.linkedEstimates}
        currentEstimatedBill={currentEstimatedBill}
        setGrandTotal={setGrandTotal}
        hideAdminFeeTooltip={hideAdminFeeTooltip}
        shouldShowProratedCharge={shouldShowProratedCharge}
        currency={currency}
        isDesignIteration1Enabled={isDesignIteration1Enabled}
      />
    );
  };

  if (isDesignIteration1Enabled) {
    return (
      <div className="bill-estimate-price-difference-container bill-estimate-price-difference-container-new">
        {renderPriceDifferenceContent()}
      </div>
    );
  }

  return (
    <div className="bill-estimate-price-difference-container">
      <div>
        <div className="price-tag">
          <Field label={'Next price estimate'} name="nextPriceEstimate" id="nextPriceEstimate">
            {renderPriceDifferenceContent}
          </Field>
        </div>
      </div>
    </div>
  );
};
